import axios from 'axios';
import isDev from '@utils/is-dev'

export async function getHeaderEnrichment() {
  let { data } = await axios.get('http://apps.mobivs.com/HE/index.php');
  await new Promise((r) => setTimeout(r, 1000));

  if(isDev()) {
    return '233553659429';
  }
  return data?.MSISDN || false;
}